import { render, staticRenderFns } from "./englishProject.vue?vue&type=template&id=6b9bb2b9&scoped=true"
import script from "./englishProject.vue?vue&type=script&lang=js"
export * from "./englishProject.vue?vue&type=script&lang=js"
import style0 from "./englishProject.vue?vue&type=style&index=0&id=6b9bb2b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bb2b9",
  null
  
)

export default component.exports